module.exports = __webpack_public_path__ + "img/door-closed-fill.853491ad.svg";